import request from '@/utils/request'
// export function Detail(shopId) {
//   return request({
//     url:`/sys/susdaily/dayDaliy/${shopId}`,
//     method:'get'
//   })
// }
export function Detail(params) {
  return request({
    url:`/sys/susdaily/dayChooseDaliy`,
    params
  })
}
export function Save(data) {
  return request({
    url:'/sys/susdaily/save',
    method:'post',
    data
  })
}
export function Update(data) {
  return request({
    url:'/sys/susdaily/update',
    method:'post',
    data
  })
}